import React, { Component } from 'react';

import swal from 'sweetalert2';
import axios from 'axios/index';
import {SkyLightStateless} from 'react-skylight';

import urls from '../../../../../utils/urls';
import { ajaxHandler } from '../../../../../utils/errors';
import { tokenHeader } from '../../../../../utils/headers';
import translator from '../../../../../utils/translations';
import {Spinner} from "../../../../../components/Loading/Spinner";


export default class DischargeAudit extends Component {

    constructor (props) {
        super(props);

        this.state = {
            ajaxInProgress: false,
            trip: props.trip,
            discharge: props.discharge,
            showModal: true,
            reasons: null,

            // Fields
            audit_reason: '',
            audit_observations: '',
            initial_totalizer: ''
        };

    }

    componentDidMount(){
        this._fetchReasons();
    }

    _initializeHtml = () => {
        window.initializeSelects('body');
        window.bindSelectAction(this.reasonSelect, this._handleSelectChange);
    };

    _fetchReasons = () => {
        const REASONS_URL = `${urls.API_ROOT}/api/v1/audit_reasons/`;
        axios.get(REASONS_URL, tokenHeader())
            .then(response => {
                this.setState({
                    reasons: response.data
                }, this._initializeHtml);

            })
            .catch((error) => ajaxHandler(error));
    };

    _closeModal = () => {
        this.setState({showModal: false});
    };

    _handleInput = (prop, value) => {
        // Custom validations
        this.setState({[prop]: value})
    };

    _handleSelectChange = (ev) => {
        let target = ev.target;
        this.setState({
            [target.getAttribute('data-state-var')]: target.value
        });
    };

    _submitAudit = () => {
        let {audit_reason, audit_observations, initial_totalizer, discharge} = this.state;

        if(audit_reason === '' || audit_observations === '' || initial_totalizer === '' || initial_totalizer <= 0){
            swal({
                title: 'Error',
                html: '<div class=\'swal-container\'><p>Por favor, complete todo el formulario para continuar</p></div>',
                type: 'error'
            });
            return false;
        }
        this.setState({ajaxInProgress: true});

        let data = {audit_reason, audit_observations, initial_totalizer, discharge: discharge.id};

        const AUDIT_URL = `${urls.API_ROOT}/api/v1/discharge/audit`;
        axios.post(`${AUDIT_URL}`, data, tokenHeader())
            .then(this._onSubmitSuccess)
            .catch(this._onSubmitError)

    };

    _onSubmitSuccess = (response) => {
        swal({
            title: 'Auditoría enviada',
            html: 'La auditoría se ha ingresado correctamente. Espere unos segundos por favor',
            type: 'success',
            showConfirmButton: false,
            timer: 3000
        });

        setTimeout(this.props.reloadTrip, 3000);
    };

    _onSubmitError = (error) => {
        this.setState({ajaxInProgress: false});
        try {
            let response = error.response;
            if (response.status === 400) {
                let keys = Object.keys(response.data);
                let details = '';
                for (let i in keys) {
                    details = `${details} <p><b>${translator.getFieldName(keys[i])}:</b> ${response.data[keys[i]].join(' ')}</p>`;
                }
                let body = `<div class='swal-container'><p>Se han encontrado los siguientes errores: </p>${details}</div>`;
                swal({
                    title: 'No se ha podido guardar la descarga',
                    html: body,
                    type: 'error'
                });
            } else {
                ajaxHandler(error);
            }
        }
        catch (e) {
            ajaxHandler(error);
        }
    };

    render () {
        let {trip} = this.state;
        if (!trip) return <div/>;

        // If there's an ajax call in progress or if user can not edit
        let disableButtons = this.state.ajaxInProgress;

        let modalStyle = {
            boxShadow: 'none'
        };

        return (
            <div>
                <SkyLightStateless
                    isVisible={true}
                    dialogStyles={modalStyle}
                    title={<h3 className="center" style={{fontSize: '30px'}}>Auditoría del Meter</h3>}
                    closeOnEsc={false}
                    hideOnOverlayClicked={false}
                    closeButtonStyle={{display: 'none'}}
                >

                    {!this.state.reasons &&
                        <Spinner />
                    }

                    {this.state.reasons &&
                    <div className={"row margin-top-20 text-left"}>
                        <div className={"col s12"}>
                            <p>{this.props.message}</p>
                        </div>
                        <div className={"col s6 margin-top-30"}>
                            <div className={`input-field ${this.state.warn_reason ? 'error-input' : ''}`}>
                                <label className="active">Motivo auditoría</label>
                                <select defaultValue={this.state.audit_reason}
                                        data-state-var="audit_reason" ref={ref => {
                                    this.reasonSelect = ref
                                }}>
                                    <option value="">Seleccione el motivo</option>
                                    {this.state.reasons && this.state.reasons.map(reason => {
                                        return <option key={reason.id} id={reason.id}
                                                       value={reason.id}>{reason.description}</option>
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className={"col s6 margin-top-30"}>
                            <div className={"input-field"}>
                                <input placeholder={"Ingrese un valor"} value={this.state.initial_totalizer}
                                       type={"number"}
                                       onChange={(ev) => this._handleInput('initial_totalizer', ev.target.value)}
                                       className={"no-margin"}
                                />
                                <label className="active">Valor Inicial Meter</label>
                            </div>
                        </div>
                        <div className={`col s12 input-field ${this.state.warn_observation ? 'error-input' : ''}`}>
                            <label className="active">Observaciones</label>
                            <textarea
                                className={"materialize-textarea dispatch-textarea"} rows={4}
                                onChange={(ev) => this._handleInput('audit_observations', ev.target.value)}
                                defaultValue={this.state.audit_observations}
                            />
                        </div>
                        <div className={"col s12 center margin-top-30"}>
                            <button className={`btn btn-shell-empty z-depth-0 ${disableButtons ? 'disabled' : ''}`}
                                    onClick={this.props.closeAudit}>
                                Cancelar
                            </button>
                            <button className={`btn btn-shell z-depth-0 ${disableButtons ? 'disabled' : ''}`}
                                    onClick={this._submitAudit}>
                                Enviar auditoría
                            </button>
                        </div>
                    </div>
                    }
                </SkyLightStateless>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/Discharge/DischargeAudit.js